import { useState, createContext } from "react";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { endpoints } from "../../Utils/UrlEnum";
import { ClientMessageModel } from "../../Utils/Models";
import { Button, Chip } from "@mui/material";
import { TablesIds } from "../../Utils/Constants";
import { ETableEditAction } from "../../Utils/Enums";
import { Refresh } from "@mui/icons-material";
import MessageModal from "./MessageModal";
import { StatusItem } from "../../Utils/Types";

export const CRUDContext = createContext(new ClientMessageModel());
interface ClientsMessagesTableProps {
  statuses?: StatusItem[] | null;
}

export default function ClientsMessagesTable({
  statuses,
}: ClientsMessagesTableProps) {
  const [contextValue, setContextValue] = useState(new ClientMessageModel());
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();
  const [selectedMessage, setSelectedMessage] =
    useState<ClientMessageModel | null>(null);
  const [showModal, setShowModal] = useState(false);
  const clientsColumns = [
    {
      label: `${Vocabulary?.name}`,
      name: "name",
      options: {
        sort: false,
      },
    },

    {
      label: `${Vocabulary.email}`,
      name: "email",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.phone}`,
      name: "phone",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
          minHeight: 100,
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRender: (phone: string) => {
          return (
            <>
              <Chip
                color="primary"
                key={phone}
                label={phone}
                style={{
                  margin: 5,
                }}
              />
            </>
          );
        },
      },
    },
    {
      label: `${Vocabulary.type}`,
      name: "type",
    },
    {
      label: `${Vocabulary.status}`,
      name: "status",
    },
    {
      label: `${Vocabulary.message}`,
      name: "message",
    },
  ];

  const handleRowClick = (rowData: ClientMessageModel) => {
    setSelectedMessage(rowData);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMessage(null);
  };

  const handleSaveMessage = async () => {
    setTriggerReload((prev) => !prev);
  };

  const getRowStyle = (rowData: ClientMessageModel) => {
    if (!statuses || !rowData?.status) return {};
    const statusItem = statuses.find((s) => s.name === rowData.status);
    if (statusItem?.color) {
      return { backgroundColor: statusItem.color };
    }
    return {};
  };

  return (
    <div>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          buttons={
            <Button
              onClick={() => setTriggerReload(true)}
              style={{ marginLeft: 10 }}
              variant="contained"
            >
              <Refresh />
            </Button>
          }
          hideAddButton
          onEditAction={ETableEditAction.NONE}
          onRowClick={handleRowClick}
          title={Vocabulary.clientMessages}
          columns={clientsColumns}
          shouldTriggerStorageUpdate={true}
          CRUDEndPoint={endpoints.messages.main}
          id={TablesIds.clientMessages}
          setContextValue={setContextValue}
          triggerReload={triggerReload}
          getRowStyle={getRowStyle}
        ></MUIDataTableCustomStyle>

        <MessageModal
          open={showModal}
          onClose={handleCloseModal}
          message={selectedMessage}
          onSave={handleSaveMessage}
          statuses={statuses || null}
        />
      </CRUDContext.Provider>
    </div>
  );
}
